import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { Store } from '@ngxs/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StudyAreaAccessService } from '../../services/study-area-access.service';
import { DfpSpecialist, DfpSpecialistRequest } from '../../interfaces/dfpspecialist';
import { UserState } from 'src/app/state/user/user.state';
import { NotificationsActions } from 'src/app/state/notifications/notifications.actions';
import { Severity } from 'src/app/global/enums/severity';
import { PredictorModelActions } from 'src/app/state/predictor-model/predictor-model.actions';

@Component({
  selector: 'app-toggle-dfpspecialist-modal',
  templateUrl: './toggle-dfpspecialist-modal.component.html',
  styleUrl: './toggle-dfpspecialist-modal.component.scss'
})
export class ToggleDfpspecialistModalComponent implements OnInit {

    form: FormGroup;
    model: any = {};
    options: FormlyFormOptions = {};
  
    fields: FormlyFieldConfig[] = [];
    dfpSpecialist: DfpSpecialist[] = [];
    currentdfpSpecialistEmail: string = '';
    userProfile : any;
  
    mode: 'add' | 'edit' = 'add';

    
      constructor(
        private readonly fb: FormBuilder,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private readonly store: Store,
        private readonly studyAreaService: StudyAreaAccessService

      ) {
        this.form = this.fb.group({});
      }
  

   ngOnInit(): void {
  this.userProfile = this.store.selectSnapshot(UserState.userProfile);

     this.studyAreaService.getAllDfpSpecialists().subscribe((data: any) => {
    console.log('API returned DfpSpecialists:', data);
    this.dfpSpecialist = data.$values;  
    this.fields = [
    this.getSpecialistSelectField()
    // other fields if any
  ];
  });
    const { mode, studyArea } = this.config.data;
    this.mode = mode;
    


    if (this.mode === 'edit') {       
      this.currentdfpSpecialistEmail = this.config.data.studyArea.dfpSpecialistEmail ?? '';
    }
        
    
  }
  getSpecialistSelectField(): FormlyFieldConfig {
  return {
    key: 'specialistId',
    type: 'select',
    className: 'p-col-12 p-md-12 basin-p-0',
    props: {
      label: 'Select User',
      required: true,
      placeholder: 'Select User',
      appendTo: 'body',
      dropdownStyle: {
        'max-height': '200px',
        'overflow-y': 'auto'
      },
      options: this.dfpSpecialist.map(option => ({
        label: option.userName,
        value: option.specialistId,
        disabled: this.shouldDisableAlreadySelectedOption(option),
      })),
    },
  };
}
   

 shouldDisableAlreadySelectedOption(specialist: DfpSpecialist): boolean {
  // Only disable options in edit mode  

  // Disable if the selected specialist is the current user
  if (specialist.userEmail === this.userProfile.email) {
    return true;
  }

  // Disable if the specialist is the one already assigned
  if (specialist.userEmail === this.currentdfpSpecialistEmail) {
    return true;
  }

  // Otherwise, allow selection
  return false;
}


  onCancel()
  {
    this.ref.close();
  }

  onSave()
  {
    let request = {} as DfpSpecialistRequest;
    if (this.form.valid) {
      const formValue = this.form.value;
      const selectedSpecialist = this.dfpSpecialist.find(s => s.specialistId === formValue.specialistId);
      request.studyAreaId =  this.config.data.studyArea.id ;
      request.dfpSpecialist = selectedSpecialist ? selectedSpecialist.userName : '';
      request.dfpSpecialistEmail = selectedSpecialist ? selectedSpecialist.userEmail : '';
      request.isShared = true;
      this.updateDfpSpecialist(request);
      this.ref.close();
    }
    }
    updateDfpSpecialist(request:DfpSpecialistRequest)
    {
       this.studyAreaService
          .updateDfpSpecialists(request)
          .subscribe({
            next: (updatedLicense) => {             
              this.store.dispatch(
                new NotificationsActions.Toast(
                   'Study area successfully shared with DFP Specialist.',
                  Severity.Success
                )
              );
              this.store.dispatch(new PredictorModelActions.GetStudyAreas());
              this.store.dispatch(new PredictorModelActions.OpenStudyAreaDropdown());
            },
            error: (err) => {
              console.error('Error updating license:', err);
              this.store.dispatch(
                new NotificationsActions.Toast(
                   'Failed to share study area with DFP Specialist. Please try again later.',
                  Severity.Error
                )
              );
            },
          });

    }  


  }



